import {ValueObject} from '@s-ui/domain'
import {toQueryString} from '@s-ui/js/lib/string'

import {ConfigContext} from '../../config/context/index.js'
import {FilterBodyTypeIdsSearchValueObject} from '../../search/ValueObjects/FilterBodyTypeIdsSearchValueObject.js'
import {FilterFuelTypeIdsSearchValueObject} from '../../search/ValueObjects/FilterFuelTypeIdsSearchValueObject.js'
import {FilterIdsArraySearchValueObject} from '../../search/ValueObjects/FilterIdsArraySearchValueObject.js'
import {FilterPriceSearchValueObject} from '../../search/ValueObjects/FilterPriceSearchValueObject.js'
import {FilterVehiclesSearchValueObject} from '../../search/ValueObjects/FilterVehiclesSearchValueObject.js'

export class GetSuggestedVehiclesRequest extends ValueObject {
  #bodyTypeIdsFilter
  #fuelTypeIdsFilter
  #makeIdsFilter
  #priceFilter
  #seatsFilter

  constructor({bodyTypeIdsFilter, fuelTypeIdsFilter, makeIdsFilter, priceFilter, seatsFilter}) {
    super()
    this.#bodyTypeIdsFilter = bodyTypeIdsFilter
    this.#fuelTypeIdsFilter = fuelTypeIdsFilter
    this.#makeIdsFilter = makeIdsFilter
    this.#priceFilter = priceFilter
    this.#seatsFilter = seatsFilter
  }

  static create({from, to, bodyTypeIds = [], fuelTypeIds = [], seats = [], makeIds = []}) {
    const priceFilter = from || to ? FilterPriceSearchValueObject.create({price: {from, to}}) : null

    const bodyTypeIdsFilter = bodyTypeIds.length > 0 ? FilterBodyTypeIdsSearchValueObject.create({bodyTypeIds}) : null

    const fuelTypeIdsFilter = fuelTypeIds.length > 0 ? FilterFuelTypeIdsSearchValueObject.create({fuelTypeIds}) : null

    const seatsFilter = seats.length > 0 ? FilterIdsArraySearchValueObject.createForNumbers({value: seats}) : null

    const makeIdsFilter =
      makeIds.length > 0
        ? FilterVehiclesSearchValueObject.createFromMakeIds({config: ConfigContext, ids: makeIds})
        : null

    return new GetSuggestedVehiclesRequest({
      bodyTypeIdsFilter,
      fuelTypeIdsFilter,
      makeIdsFilter,
      priceFilter,
      seatsFilter
    })
  }

  get value() {
    return {
      ...(this.#priceFilter && this.#priceFilter.value),
      ...(this.#bodyTypeIdsFilter && {bodyTypeIds: this.#bodyTypeIdsFilter.value}),
      ...(this.#fuelTypeIdsFilter && {fuelTypeIds: this.#fuelTypeIdsFilter.value}),
      ...(this.#seatsFilter && {seats: this.#seatsFilter.value}),
      ...(this.#makeIdsFilter && {makeIds: this.#makeIdsFilter.value.map(v => v.makeId)})
    }
  }

  toQueryString() {
    const queryParams = {}

    if (this.#priceFilter) {
      const price = this.#priceFilter.value
      if (price.from) queryParams.minPrice = price.from
      if (price.to) queryParams.maxPrice = price.to
    }

    if (this.#bodyTypeIdsFilter) {
      queryParams.bodyTypeIds = this.#bodyTypeIdsFilter.value.join(',')
    }

    if (this.#fuelTypeIdsFilter) {
      queryParams.fuelTypeIds = this.#fuelTypeIdsFilter.value.join(',')
    }

    if (this.#seatsFilter) {
      queryParams.seats = this.#seatsFilter.value.join(',')
    }

    if (this.#makeIdsFilter) {
      queryParams.makeIds = this.#makeIdsFilter.value.map(v => v.makeId).join(',')
    }

    return toQueryString(queryParams)
  }
}
